import React from 'react';
import { Box, Typography } from '@mui/material';
import { vortxTypography } from '@vortx/shared-ui';
import { alpha, keyframes } from '@mui/material/styles';
import { COLORS } from '../results/ResultsDesignTokens';

const neonPulse = keyframes`
    0%, 100% { box-shadow: 0 0 20px currentColor, 0 0 40px currentColor, 0 0 60px currentColor; }
    50% { box-shadow: 0 0 30px currentColor, 0 0 60px currentColor, 0 0 90px currentColor; }
`;

export default function GoNogoBanner({ passed, loading }) {
    if (loading) {
        return (
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                py: 4,
            }}>
                <Typography sx={{
                    fontFamily: vortxTypography.mono,
                    fontSize: '1rem',
                    color: COLORS.text.muted,
                }}>
                    Awaiting validation results...
                </Typography>
            </Box>
        );
    }

    const color = passed ? COLORS.efficiency : COLORS.loss;
    const label = passed ? 'GO' : 'NO-GO';

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            py: 3,
        }}>
            {/* Circular badge */}
            <Box sx={{
                width: 120,
                height: 120,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: `3px solid ${color}`,
                color: color,
                animation: `${neonPulse} 2s ease-in-out infinite`,
                bgcolor: alpha(color, 0.05),
            }}>
                <Typography sx={{
                    fontFamily: vortxTypography.heading,
                    fontSize: '1.75rem',
                    fontWeight: 900,
                    color: color,
                    textShadow: `0 0 20px ${color}, 0 0 40px ${alpha(color, 0.5)}`,
                    letterSpacing: '0.05em',
                }}>
                    {label}
                </Typography>
            </Box>

            {/* Subtitle */}
            <Typography sx={{
                fontFamily: vortxTypography.mono,
                fontSize: '0.7rem',
                color: COLORS.text.muted,
                mt: 2,
                textTransform: 'uppercase',
                letterSpacing: '0.15em',
            }}>
                Production Readiness
            </Typography>
        </Box>
    );
}
